<div  class="content-middle">
    <div style="text-align: center;">
        An internal error occurred and was logged.
        <br>Please try again later or contact the administration team.<br><br>
        Sorry for any inconvenience.<br><br>
        <a href="/dashboard">Press here to continue</a><br>
    </div>

</div>